import { memo } from 'react';
import { type BuildFormControl } from '../type';
import { EditableQuizCard } from './EditableQuizCard';
import { QuizControlProvider } from './QuizControlProvider';
interface EditableQuizCardWithProviderProps {
  id: string;
  index: number;
  control: BuildFormControl;
}

/**
 * Memoized wrapper component for EditableQuizCard with its QuizControlProvider.
 *
 * This component prevents unnecessary re-renders when editing a single card in a list.
 * By wrapping both the provider and card in React.memo, we ensure that individual cards
 * only re-render when their specific props (id, index, or control) change, not when
 * sibling cards are edited.
 *
 * Performance optimization:
 * - React.memo performs shallow comparison of props
 * - Only re-renders if id, index, or control reference changes
 * - Prevents list-wide re-renders when editing individual cards
 */
export const EditableQuizCardWithProvider = memo(({
  id,
  index,
  control
}: EditableQuizCardWithProviderProps) => {
  return <QuizControlProvider control={control} index={index} id={id}>
        <EditableQuizCard id={id} />
      </QuizControlProvider>;
});
EditableQuizCardWithProvider.displayName = 'EditableQuizCardWithProvider';